/**
 * Switch for the browser's speech recognition (B.6). Off, the record button disappears and
 * the page works with the keyboard only (typing, or the keyboard's own dictation).
 */
export const INSPREKEN_WEB_SPEECH = true

/** The version of the first-use notice (B.6). Sent with every new capture. */
export const NOTICE_VERSION = 1

/** A capture needs at least this many characters before it is saved or processed. */
export const MIN_CHARS = 20

/** The server's limit; `GET /status` returns the live value. */
export const MAX_CHARS = 10_000

/** One recording stops after five minutes; the text carries on when the user taps again. */
export const MAX_RECORDING_MS = 5 * 60 * 1000

/** Autosave fires this long after the last change. */
export const AUTOSAVE_MS = 2000

/** A local copy older than this is thrown away. */
export const LOCAL_DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

/** The process call is abandoned after this long; the caller polls for the result instead. */
export const PROCESS_TIMEOUT_MS = 45_000

/** Pauses between polls: 1, 2, 4, 8 s, then every 10 s. */
export const POLL_DELAYS_MS = [1000, 2000, 4000, 8000]
export const POLL_STEADY_MS = 10_000

export const DRAFT_KEY_PREFIX = 'vonk.inspreken.draft.'
export const NOTICE_KEY = 'vonk.inspreken.notice'
